import React from 'react';

const FallbackUI = ({ error, resetErrorBoundary }) => {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-red-50 text-red-900 p-6">
            <h1 className="text-3xl font-bold mb-4">Something went wrong</h1>
            <p className="mb-6 text-center max-w-md">
                We encountered an unexpected error. Our team has been notified.
            </p>
            {process.env.NODE_ENV === 'development' && (
                <pre className="bg-red-100 p-4 rounded mb-6 overflow-auto max-w-full text-sm">
                    {error.message}
                </pre>
            )}
            <button
                onClick={resetErrorBoundary}
                className="px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
            >
                Try Again
            </button>
        </div>
    );
};

export default FallbackUI;
